<template>
    <div class="city-picker-container">
      <div @click="e_openPick" class="city-picker-box">
        <div class="city-picker-input" :class="(valueData?'':(nullClass||'null '))+(classes||'')"   @click="e_openPick">{{ valueData ? valueData : placeholder }}</div>
        <div class="city-right" :style="{'background-image':rightIcon?('url('+ rightIcon +')'):''}"></div>
      </div>
      <div class="city-popup-wrap" :style="maxWidth?('max-width:'+maxWidth+'px;left:50%;transform:translateX(-50%);'):''" :class="{show:showPopup}" @click="click_out">
        <div class="city-popup-content" @click="click_inner">
          <div class="city-popup-title">
            <div class="city-title">{{title||'请选择城市'}}</div>
            <!-- <img src="https://azure-shop.obs.cn-south-1.myhuaweicloud.com/closeIcon.png" @click="e_closePick" /> -->
            <i class="city-icon-item" @click="e_closePick"></i>
          </div>
          <div class="city-popup-select">
            <span class="city-show" @click="e_selectProvince" :class="{'city-active': !provinceItem.nodeName}">{{provinceItem.nodeName ? provinceItem.nodeName : '请选择'}}
              <span class="line"></span>
            </span>
            <span class="city-show" v-if="provinceItem.nodeName" @click="e_selectCity" :class="{'city-active': !cityItem.nodeName}">{{cityItem.nodeName ? cityItem.nodeName : '请选择'}}
              <span class="line"></span>
            </span>
          </div>
          <div class="city-popup-pick" :class="{isTabBar: isTabBar}">
            <span class="city-pick-item" v-show="showProvince" v-for="(item) in dataList" :key="item.id" :class="{'pick-active': item.nodeName === provinceItem.nodeName}" @click="e_pickProvince(item)">{{ item.nodeName }}
              <span class="city-selected"></span>
            </span>
            <span class="city-pick-item" v-show="showCity" v-for="(item) in cityList" :key="item.id" :class="{'pick-active': item.nodeName === cityItem.nodeName}" @click="e_pickCity(item)">{{ item.nodeName }}
              <span class="city-selected"></span>
            </span>
          </div>
          </div>
      </div>
    </div>
</template>
<script>
import axios from "@/libs/axios.js";
import Event from '@/libs/event.js'
let citys = null;
let addressCallback = [];
function getAddress(success) {
  if (citys) return success(citys);
  if (!addressCallback.length) {
    axios({
      method: "get",
      url: `/power/carChargingOrder/noAuth/front/v3.2.0/get4City`,
      data: {},
      headers: {
        Authorization: 'null'
      }
    }).then(rep => {
      if (addressCallback&&addressCallback.length) {
        Event.$emit('getAddress',rep.data.data)
        addressCallback.forEach(v => v(rep));
        addressCallback = [];
        citys = rep;
      }
    });
  }
  addressCallback.push(success);
}
export default {
  name:'city-picker',
  props: {
    title: String,
    classes: String,
    nullClass: String,
    value: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: '请选择城市'
    },
    maxWidth: {
      type: Number,
      default: null
    },
    rightIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isTabBar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valueData: '',
      dataList: [],
      provinceItem:{},
      cityItem:{},
      cityList: [],
      showPopup: false,
      showProvince: true,
      showCity: false,
      showDistrict: false,
      showCityList: false,
      showDistrictList: false,
    }
  },
  watch:{
    value (val, oldVal) {
      if (val) {
        if (val[0]&&(!this.provinceItem.nodeName||this.provinceItem.nodeName !== val[0].nodeName)) {
          let item = val[0];
          this.e_pickProvince(item, true);

        }
        if (val[1]&&(!this.cityItem.nodeName||this.cityItem.nodeName !== val[1].nodeName)) {
          let item = val[1];
          this.e_pickCity(item,  true);
        }

      }
    }
  },
  mounted() {
    getAddress(res => {
      this.dataList = [...res.data.data];
    });
  },
  methods: {
    clearValue(){
      this.valueData = ''
      this.provinceItem = {}
      this.cityItem = {}
      this.cityList = []
      this.showPopup = false
      this.showProvince = true
      this.showCity = false
      this.showDistrict = false
      this.showCityList = false
      this.showDistrictList = false
    },
    click_inner(){
      return false
    },
    click_out(e){
      if(e.target.classList[0]==='city-popup-wrap'){
        this.showPopup = false;
        this.quitBodyScroll()
      }
    },
    e_openPick() {
      if (this.disabled) return
      if (this.dataList&&this.dataList.length) {
        this.showPopup = true;
      } else {
        getAddress(res => {
          this.dataList = [...res.data.data];
          this.showPopup = true;
        })
      }
      this.quitBodyScroll()
    },
    e_closePick () {
      this.showPopup = false;
      this.quitBodyScroll()
    },
    e_selectProvince () {
      this.showProvince = true;
      this.showCity = false;
      this.showDistrict = false;
    },
    e_selectCity () {
      this.showProvince = false;
      this.showCity = true;
      this.showDistrict = false;
    },
    e_selectDistrict () {
      this.showProvince = false;
      this.showCity = false;
      this.showDistrict = true;
    },

    e_pickProvince (item, setVauleOnly) {
      // console.log('省级',item)
      this.provinceItem = item;
      this.cityItem ={}
      this.district = '';
      this.showProvince = false;
      this.showCity = true;
      this.showDistrict = false;
      if(item.nodeCode==="710000"){
        this.showPopup = false;
        this.showProvince = true;
        this.showCity = false;
        this.showDistrict = false;
        this.valueData = `${item.nodeName}`
        this.cityItem = {nodeCode:'',nodeName:''};
        !setVauleOnly&&this.$emit('address-input', [this.provinceItem,this.cityItem]);
        this.quitBodyScroll()
        return
      }
      this.cityList = item.children
    },
    e_pickCity (item,setVauleOnly) {
      //  console.log('市级',item)
      this.cityItem = item;
      this.district = '';
      this.showProvince = false;
      this.showCity = false;
      this.showDistrict = true;
      this.valueData = `${this.provinceItem.nodeName} ${this.cityItem.nodeName}`
      !setVauleOnly&&this.$emit('address-input', [this.provinceItem,this.cityItem]);
      setTimeout(() => {
        this.showPopup = false;
        this.showProvince = true;
        this.showCity = false;
        this.showDistrict = false;
        this.quitBodyScroll()
      }, 50)
    },
    quitBodyScroll(){
      if(this.showPopup){  //显示城市遮罩就阻止底部页面滑动
          document.querySelector('body').setAttribute('style', 'overflow: hidden;')
      }else{
          document.querySelector('body').removeAttribute('style')
      }
    }
  },

}
</script>
<style lang="scss">
@import "@/common/scss/_themes.scss";
.city-picker-container {
  font-size: 30px;
  line-height: 36px;
}

.city-picker-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.city-picker-container .city-picker-input {
  font-family:PingFangSC-Regular;
  font-size: 30px !important;
  text-align: left;
  height: 36px;
  line-height: 36px;
  max-width: 450px;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #181A24;
}
.city-picker-container .city-picker-input.null {
  color: #CCCCCC;
}
.city-picker-container  .city-right{
  width:30px;
  height:30px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image:url(https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20200805151400442-icon_common_arrows_30_dow_gray%403x.png);
}

.city-popup-wrap {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  opacity: 0;
  transition: .3s ease-in-out all;
  visibility: hidden;
}
.city-popup-wrap.show {
  visibility: visible;
  opacity: 1;
}
.city-popup-wrap .city-popup-content {
  width: 100%;
  height: 820px;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 999;
  background: #fff;
  transform: translateY(100%);
  transition: .3s ease-in-out transform;
}
.city-popup-wrap.show .city-popup-content {
  transform: translateY(0);
}
.city-popup-wrap .city-popup-title {
  line-height: 50px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  font-size: 36px;
  color: #181A24;
  font-weight: bold;
}

.city-popup-wrap .city-popup-title .city-icon-item {
  width:36px;
  height:36px;
  display: block;
  box-sizing: content-box;
  background: url('https://azure-shop.obs.cn-south-1.myhuaweicloud.com/closeIcon.png') no-repeat  center center/contain;
  transform: translateY(-50%);
  position: absolute;
  right: 40px;
  top: 48px;
}

.city-popup-wrap .city-popup-select {
  line-height: 23px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size:26px;
  border-bottom: 1px solid #ddd;
}
.city-popup-wrap .city-popup-select .city-show {
  position: relative;
  padding: 14px 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 110px;
  color: #181A24;
}
.city-popup-wrap .city-popup-select .city-show.city-active .line{
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -15px;
  width: 30px;
  height: 4px;
  border-radius: 2px;
  background-color: $themeColor;
}
.city-popup-wrap .city-popup-pick {
  height: 660px;
  padding: 20px 30px;
  overflow-y: scroll;
}

.isTabBar {
  padding-bottom: 186px !important;
}
.city-popup-wrap .city-popup-pick .city-pick-item {
  font-size:26px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(24,26,36,1);
  line-height:26px;
  padding: 25px 0;
  padding-left: 20px;
  width: 100%;
  color: #181A24;
  display: block;
}
.city-popup-wrap .city-popup-pick .city-pick-item.pick-active {
  color: $themeColor;
  display: inline-flex;
  align-items: center;
}
.pick-active .city-selected{
  display: inline-block;
  margin-left: 10px;
  width:24px;
  height:24px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image:url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20220228160323070-icon_common_select_36_sel_blue@3x.png
);
}
</style>
